var map = {
	"./1/image.png": "5979",
	"./1/image2.png": "13ed",
	"./2/image.png": "9719",
	"./2/image2.png": "5736",
	"./3/image.png": "2c99",
	"./3/image2.png": "c0c9",
	"./4/image.png": "594c",
	"./4/image2.png": "ce81",
	"./5/image.png": "4f2b",
	"./5/image2.png": "aa23"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf8e";